module.exports = __webpack_public_path__ + "assets/e952f303ba5b3591a3c5e40706788aaf.png";